'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'feather-pointed';
var width = 512;
var height = 512;
var aliases = ["feather-alt"];
var unicode = 'f56b';
var svgPathData = ['M71.8 356.4c3.3 12.2 9.4 23.2 17 33.3 74.2-74.2 148.5-148.5 222.7-222.7 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-74.2 74.2-148.5 148.5-222.7 222.7 10 7.6 21 13.7 33.3 17 44.7 12.1 114.4 13.8 182.5-31.2 12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2 0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1 4.4-6.4 8.6-12.9 12.6-19.6 6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2 0-4.1 2.7-7.6 6.5-8.8L456 245.8c4.6-1.4 8.4-4.8 10.2-9.3 28.9-73.5 42.2-150.4 46.2-199.7 .8-9.9-3-19.6-10-26.6S485.7-.7 475.7 .1C392 7 229 40.5 137.9 131.6 57.8 211.7 57.2 302.3 71.8 356.4z', 'M24.5 512c-6.2 0-12.3-2.3-17-7-9.4-9.4-9.4-24.6 0-33.9l304-304c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41.5 505c-4.7 4.7-10.8 7-17 7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFeatherPointed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;